import { apiGet, apiPost } from './client'

export interface LoginRequest { username: string; password: string }

export interface LoginResponse {
  token: string
  expires_at: string  // ISO
  username?: string
}

export interface CheckResponse {
  authenticated: boolean
  username?: string | null
}

export interface ChangePasswordRequest {
  current_password: string
  new_password: string
}

export interface ChangePasswordResponse {
  token: string
  expires_at: string  // ISO — fresh token; old token still valid until natural expiry
}

export const login = (req: LoginRequest) =>
  apiPost<LoginResponse>('/auth/login', req)

export const checkAuth = () =>
  apiGet<CheckResponse>('/auth/check')

export const changePassword = (req: ChangePasswordRequest) =>
  apiPost<ChangePasswordResponse>('/auth/change-password', req)

export const logout = () =>
  apiPost<{ ok: boolean }>('/auth/logout', {})
